import { useState } from "react";
import axios from "axios";
import Lastmenu from "./LastMenu";
import bot from '../images/happy.png';
import you from '../images/boy.png';
import LoadingDots from "./LoadingDots";

const EnquiryForm = () => {
    const [name, setName] = useState("");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [location, setLocation] = useState("");
    const [enquireType, setEnquireType] = useState("");
    const [showFrame, setShowFrame] = useState(false);
    const [time] = useState(new Date()); // Time display
    const [loading, setLoading] = useState(false); // Handle loading state during submission

    const handleChange1 = (e) => {
        const value = e.target.value;
        if (/^[A-Za-z\s]*$/.test(value)) {
            setName(value);
        }
    };

    const handleChange2 = (e) => {
        const value = e.target.value;
        if (/^\d{0,10}$/.test(value)) {
            setMobile(value);
        }
    };

    const handleChange3 = (e) => {
        setEmail(e.target.value);
    };

    const handleChange4 = (e) => {
        const value = e.target.value;
        if (/^[A-Za-z\s]*$/.test(value)) {
            setLocation(value);
        }
    };

    const handleChange5 = (e) => {
        setEnquireType(e.target.value);
    };

    const isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (mobile.length !== 10) {
            alert("Please enter a valid 10-digit mobile number.");
            return;
        }
        if (!isValidEmail(email)) {
            alert("Please enter a valid email address.");
            return;
        }

        setLoading(true); // Set loading to true when starting the submission

        try {
            const response = await axios.post("https://poultry-chatbot-api.onrender.com/submit_enquiry", {
                name: name,
                email: email,
                phone: mobile,
                location: location,
                poultry_type: enquireType
            });

            if (response.status === 200 && response.data.message === "Enquiry submitted successfully") {
                setShowFrame(true);
            } else {
                alert("Failed to submit the enquiry. Please try again.");
            }
        } catch (error) {
            alert("Error: " + (error.response?.data?.error || "Failed to connect to the server."));
        } finally {
            setLoading(false); // Set loading to false after submission
        }
    };

    return (
        <>
            <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time.toLocaleTimeString()} {/* Convert Date object to string */}
            </div>

            <div className="you-message">
                <div className="frame2">Enquire Now</div>
            </div>

            {loading ? (
                <div className='frame1'>
                    <LoadingDots />
                </div>
            ) : (
                <>
                    <div className="chatbot">
                        <img src={bot} alt="bot" className="bot" />
                        <div className="chatbot-time">{time.toLocaleTimeString()}</div> {/* Convert Date object to string */}
                    </div>

                    <div className="frame1 animated-frame" style={{ textAlign: 'center' }}>
                        <div style={{ textAlign: 'center' }}><b>Enquire Now</b></div><br />
                        <input
                            type="text"
                            className="text1"
                            placeholder="Enter your name"
                            value={name}
                            onChange={handleChange1}
                        />
                        <input
                            type="text"
                            className="text1"
                            placeholder="Enter your mobile"
                            value={mobile}
                            onChange={handleChange2}
                        />
                        <input
                            type="text"
                            className="text1"
                            placeholder="Enter email"
                            value={email}
                            onChange={handleChange3}
                        />
                        <input
                            type="text"
                            className="text1"
                            placeholder="Enter your location"
                            value={location}
                            onChange={handleChange4}
                        />
                        <div style={{textAlign: 'center'}}>
                        <select
                            className="text1"
                            value={enquireType}
                            onChange={handleChange5}
                        >
                            <option value="" disabled>Select a Type</option>
                            <option>Farm Business</option>
                            <option>Feeds</option>
                            <option>Delfrez</option>
                            <option>Mothers Delight</option>
                        </select>
                        </div>
                        <br></br>
                        <div style={{textAlign: 'center'}}>
                        <button className="Menubtns" onClick={handleSubmit}>
                            Submit
                        </button>
                        </div>
                    </div>
                </>
            )}

            {showFrame && (
                <>
                      <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time.toLocaleTimeString()} {/* Convert Date object to string */}
            </div>

            <div className="you-message">
                <div className="frame2 animated-frame">Submit</div>
            </div>

            {loading ? (
                <div className='frame1 animated-frame'>
                    <LoadingDots />
                </div>
            ) : (
                <>
                    <div className="chatbot">
                        <img src={bot} alt="bot" className="bot" />
                        <div className="chatbot-time">{time.toLocaleTimeString()}</div> {/* Convert Date object to string */}
                    </div>
                    <div className="frame1 animated-frame">
                      
                            Thank you for your enquiry! Our team will give you a call soon.
                      
                    </div>
                    <Lastmenu />
                    </>
            )}
                </>
            )}
        </>
    );
};

export default EnquiryForm;
